import { Box, Chip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Colors } from '~/libs/mui/color'

export const UpComingChip = () => {
  const { t } = useTranslation()
  return (
    <Box position='absolute' top={0}>
      <Chip
        sx={{
          color: Colors.color0D0D0E,
          backgroundColor: Colors.colorFFEB3B,
          fontSize: '12px',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: '10px',
          borderBottomRightRadius: '10px',
          '& .MuiChip-label': {
            paddingLeft: '4px',
          },
        }}
        label={t('upcoming_release')}
        size='small'
      />
    </Box>
  )
}
